export default [
  { label: 'NDIA-managed', value: 'ndia-managed' },
  { label: 'Plan-managed', value: 'plan-managed' },
  { label: 'Self-managed', value: 'self-managed' }
]
